module.exports = {
      id: "kishoralo-white-usage",
      viewBox: "0 0 512 209.4",
      url: "/" + "svg-sprite-f1921bf4f6bf5e98a1b5d71e857b44f0.svg#kishoralo-white",
      toString: function () {
        return this.url;
      }
    }